export const LOAD = 'SERVER/VERSION/LOAD';
export const LOAD_SUCCESS = 'SERVER/VERSION/LOAD/SUCCESS';
export const LOAD_ERROR = 'SERVER/VERSION/LOAD/ERROR';

export const load = () => ({
  type: LOAD,
});

export const loadSuccess = version => ({
  type: LOAD_SUCCESS,
  version,
});

export const loadError = err => ({
  type: LOAD_ERROR,
  error: err,
});
